/**
 * Souběh dávky nahrávání v adminu (vize podnety-tymu-2026-10, F7.10, řez 04).
 *
 * Řádek `export const BATCH_UPLOAD_CONCURRENCY = <číslo>;` drž doslova v tomto tvaru: skripty
 * měření (`scripts/nahravani/`) ho čtou z textu souboru, protože ze `scripts/` nejde importovat
 * `@ckgo2/shared` (precedent `batches.ts`). Číslo mění jen měření souběhu
 * (`node scripts/nahravani/soubeh.mjs zapsat`), ne ruční úprava.
 */

/** Souběžná nahrání dávky v adminu; hodnotu určuje měření F7.10 (docs/e2e/rez-04-pred.md). */
export const BATCH_UPLOAD_CONCURRENCY = 6;
